<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>商户列表</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                [ID]商户名
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                地址
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                活跃度
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                入驻时间
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="merchant in currentPageMerchants" :key="merchant.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar :img="merchant.deliver_pic || defaultAvatar" size="sm" border-radius="lg" class="me-3" alt="merchant-avatar"/>
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">[{{ merchant.id }}]{{ merchant.name }}</h6>
                    <p class="text-xs text-secondary mb-0">{{ merchant.nick_name }}</p>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ merchant.address || '暂无地址' }}</p>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge :color="merchant.status === 'Online' ? 'success' : 'secondary'" variant="gradient" size="sm">
                  {{ merchant.status || 'Offline' }}
                </soft-badge>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ formattedDate(merchant.create_time) }}</span>
              </td>
              <td class="align-middle">
                <a href="javascript:;" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

         <!-- 分页控件 -->
      <div class="d-flex justify-content-center mt-3">
        <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1" class="btn btn-sm btn-secondary">
          上一页
        </button>
        <span class="mx-2">{{ currentPage }} / {{ totalPages }}</span>
        <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages" class="btn btn-sm btn-secondary">
          下一页
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import { getmerchlist } from "@/api/merch.js";  // 引入商户列表接口
import dayjs from "dayjs";

export default {
  name: "merchant-all-set",
  data() {
    return {
      merchants: [],  // 存储商户列表
      defaultAvatar: require("../../assets/img/merchant.png"),  // 默认头像
      currentPage:1,
      pageSize:10,
      totalPages:1,
    };
  },
  components: {
    SoftAvatar,
    SoftBadge,
  },
  computed: {
    currentPageMerchants(){
      const start = (this.currentPage - 1) *this.pageSize
      const end = start + this.pageSize
      return this.merchants.slice(start, end)
    }
  },
  methods: {
    // 格式化日期
    formattedDate(timestamp) {
      return dayjs.unix(timestamp).format('YYYY/MM/DD HH:mm:ss');
    },

    // 获取商户列表
    getMerchants() {
      getmerchlist().then(response => {
        if (response.code === 0) {
          this.merchants = response.desc.map(merchant => ({
            ...merchant,
            status: merchant.name.includes("店铺") ? "Offline" : "Online",  
            create_time: merchant.created_date 
          }));
          this.totalPages = Math.ceil(this.merchants.length/this.pageSize)
        } else {
          alert("获取商户列表失败：" + response.desc);
        }
      }).catch(error => {
        console.error("获取商户列表时出错：", error);
        alert("获取商户列表失败，请稍后再试。");
      });
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.currentPage = page;
    },

  },
  mounted() {
    this.getMerchants();  // 页面加载时调用接口获取商户数据
  }
};
</script>
